import React from 'react';
import '../styles/theme.css';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';

const LandingPage: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleLoginClick = () => {
    if (isAuthenticated) {
      navigate('/welcome');
    } else {
      navigate('/login');
    }
  };

  return (
    <div style={{ backgroundColor: '#f0f0f0', minHeight: '100vh' }}>
      <section style={{ 
        backgroundColor: '#1e1e1e', 
        color: 'white', 
        padding: '4rem 2rem',
        textAlign: 'center'
      }}>
        <h1 style={{ fontSize: '3rem', marginBottom: '1rem', fontWeight: 'bold' }}>
          <span style={{ color: '#7FE7D9' }}>Intelligent Investing</span>
          <br />
          <span style={{ fontSize: '2.5rem' }}>Simplified</span>
          <span style={{ color: '#7FE7D9' }}>.</span>
        </h1>
        <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>
          Advanced portfolio analytics and risk management tools designed for retail investors
        </p>
        <Button onClick={handleLoginClick}>
          Explore Features
        </Button>
      </section>

      <section id="features" style={{ padding: '4rem 2rem', maxWidth: '1200px', margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '2rem', color: '#1e1e1e' }}>Professional-Grade Tools</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
          <FeatureCard 
            title="Portfolio Analysis" 
            description="Deep dive into your portfolio's performance metrics, sector allocation, and risk factors"
          />
          <FeatureCard 
            title="Risk Management" 
            description="Advanced risk metrics, stress testing, and scenario analysis tools"
          />
          <FeatureCard 
            title="Market Intelligence" 
            description="Real-time market data, news analysis, and sentiment indicators"
          />
        </div>
      </section>

      <section style={{ backgroundColor: '#1e1e1e', color: 'white', padding: '4rem 2rem' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Why Choose VersaQuant?</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
            <FeatureCard 
              title="Institutional-Grade Analytics" 
              description="Access the same powerful tools used by professional fund managers"
              dark
            />
            <FeatureCard 
              title="Data-Driven Insights" 
              description="Make informed decisions backed by comprehensive market data"
              dark
            />
            <FeatureCard 
              title="Custom Strategies" 
              description="Build and backtest investment strategies tailored to your goals"
              dark
            />
          </div>
        </div>
      </section>

      <section style={{ padding: '4rem 2rem', maxWidth: '1200px', margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '2rem', color: '#1e1e1e' }}>Advanced Features</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
          <FeatureCard 
            title="Portfolio Optimization" 
            description="Optimize your portfolio for the best risk-adjusted returns"
          />
          <FeatureCard 
            title="Risk Analytics" 
            description="Measure and manage portfolio risk with sophisticated metrics"
          />
          <FeatureCard 
            title="Performance Attribution" 
            description="Understand what drives your portfolio's performance"
          />
        </div>
      </section>
    </div>
  );
};

const FeatureCard: React.FC<{ title: string; description: string; dark?: boolean }> = ({ title, description, dark }) => (
  <div style={{ 
    backgroundColor: dark ? '#333' : 'white', 
    color: dark ? 'white' : '#1e1e1e',
    padding: '2rem', 
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
  }}>
    <h3 style={{ marginBottom: '1rem' }}>{title}</h3>
    <p>{description}</p>
  </div>
);

export default LandingPage;
